import { EmailType } from "../../../../../constants";
import { useSteps } from "../../../../../hook";

export const useMTPSSteps = () => {
  return useSteps({
    approved: EmailType.MTPSA,
    rejected: EmailType.MTPSR,
    completed: EmailType.MTPSF,
  });
};
